import { useState } from 'react'
import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { useContextState } from '../../context/Context';
import { useAuth } from "../../store";
import logo from '../../logo.png';
import LoginModal from '../modals/LoginModal';
import AlertComponent from '../shared/AlertComponent';
import { Modal } from 'flowbite-react';

export default function SupportHeader() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [currentHeaderView, setCurrentHeaderView] = useState<string>('default');

    const { accountCTX } = useContextState();
    const { signedIn } = accountCTX;
    const { logoutCall } = useAuth();

    const handleLogOut = async () => {
        const result: any = await logoutCall();
        if (result?.res === 'success') {
            setCurrentHeaderView('logoutSuccess');
            setMobileMenuOpen(false);
        }
    };

    const handleLogin = () => {
        setCurrentHeaderView('login');
        setMobileMenuOpen(false);
    };

    const handleAfterAuth = () => {
        setCurrentHeaderView('default');
        setMobileMenuOpen(false);
    };

    return (
        <header className="top-0 z-10 bg-white sticky">
            <nav
                className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
                aria-label="Global"
            >
                <div className="flex lg:flex-1">
                    <a href="#" className="-m-1.5 p-1.5">
                        <span className="sr-only">FestiShare Support</span>
                        <img
                            className="h-8 w-auto"
                            src={logo}
                            style={{ borderRadius: '35px' }}
                            alt="FestiShare"
                        />
                    </a>
                </div>

                <div className="flex lg:hidden">
                    <button
                        type="button"
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        onClick={() => setMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Open main menu</span>
                        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>

                <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                    {signedIn ? (
                        <a onClick={handleLogOut} href="#" className="text-sm font-semibold leading-6 text-gray-900">
                            Log Out <span aria-hidden="true">&rarr;</span>
                        </a>
                    ) : (
                        <a onClick={handleLogin} href="#" className="text-sm font-semibold leading-6 text-gray-900">
                            Log In <span aria-hidden="true">&rarr;</span>
                        </a>
                    )}
                </div>
            </nav>

            <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
                <div className="fixed inset-0 z-10" />
                <Dialog.Panel className="fixed inset-y-0 top-0 right-0 z-10 flex w-full flex-col justify-between overflow-y-auto bg-white sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                    <div className="p-6">
                        <div className="flex items-center justify-between">
                            <a href="#" className="-m-1.5 p-1.5">
                                <span className="sr-only">FestiShare Support</span>
                                <img className="h-8 w-auto" src={logo} style={{ borderRadius: '35px' }} alt="FestiShare" />
                            </a>
                            <button
                                type="button"
                                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                        </div>
                        <div className="mt-6 flow-root">
                            <div className="-my-6 divide-y divide-gray-500/10">
                                <div className="py-6">
                                    {signedIn ? (
                                        <a onClick={handleLogOut} href="#" className="text-sm font-semibold leading-6 text-gray-900">
                                            Log Out <span aria-hidden="true">&rarr;</span>
                                        </a>
                                    ) : (
                                        <a onClick={handleLogin} href="#" className="text-sm font-semibold leading-6 text-gray-900">
                                            Log In <span aria-hidden="true">&rarr;</span>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog.Panel>
            </Dialog>

            {currentHeaderView === 'login' && (
                <LoginModal
                    close={false}
                    callBack={handleAfterAuth}
                    back={() => setCurrentHeaderView('default')}
                    closeButton={() => setCurrentHeaderView('default')}
                />
            )}

            {currentHeaderView === 'logoutSuccess' && (
                <Modal show onClose={handleAfterAuth} size="md" popup>
                    <Modal.Header />
                    <Modal.Body>
                        <AlertComponent
                            callBack={() => window.location.reload()}
                            type='success'
                            subject='Success'
                            message='You have been logged out successfully.'
                        />
                    </Modal.Body>
                </Modal>
            )}
        </header>
    );
}
